export default class ListItem {
    constructor (dto) {
        this.id = 0;
        this.text = 0;
        this.selected = false;

        if (dto) {
            this.id = dto.Id;
            this.text = dto.DisplayValue;
            this.selected = dto.Selected;
        }
    }
}
